module.exports = __webpack_public_path__ + "static/media/biogib.7e2f33b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/cana/nutricheck_foliar/biogib.png
// module id = 1299
// module chunks = 3